module.exports = __webpack_public_path__ + "static/img/watermark.65a26c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crm/watermark.png
// module id = TNDc
// module chunks = 2